import { FieldValues, useFormContext } from 'react-hook-form';

import { FileMimeTypes, FilePicker, FilePickerProps } from '@/modules/common';

import { maxVideoPreviewSize } from '../constants';

type FileState = {
  error: string;
  file: File | null;
};

type VideoPreviewProps = Pick<
  FilePickerProps<FieldValues>,
  'onRetry' | 'isUploading' | 'onFileChange'
> & {
  filesState: {
    [key: string]: FileState;
  };
};

export function VideoPreview({
  onRetry,
  filesState,
  isUploading,
  onFileChange,
}: VideoPreviewProps) {
  const { control } = useFormContext();

  return (
    <div className="gap-4 flex flex-col">
      <h3 className="text-2xl font-semibold text-zinc-50">Event Video</h3>
      <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-col grid-rows-6 sm:grid-rows-1 gap-6">
        <FilePicker
          control={control}
          label="Idle state video (displayed when the app first opens)"
          name="idleStateVideoPublicUrl"
          accept={[FileMimeTypes.Mp4, FileMimeTypes.Mov, FileMimeTypes.Webm]}
          onRetry={onRetry}
          useVideoIcon
          isUploading={isUploading}
          file={filesState.idleStateVideoPublicUrl?.file}
          error={filesState.idleStateVideoPublicUrl?.error}
          onFileChange={onFileChange}
          placeholder="Add video file"
          tips={
            <p className="text-sm text-zinc-500">
              The file must be in
              <span className="text-zinc-100">&nbsp;mp4 .webm .mov&nbsp;</span>
              formats and maximum size 100 MB.
            </p>
          }
          maxFileSize={maxVideoPreviewSize}
        />

        <FilePicker
          control={control}
          label="Event loading video"
          name="publicUrl"
          useVideoIcon
          accept={[FileMimeTypes.Mp4, FileMimeTypes.Mov, FileMimeTypes.Webm]}
          onRetry={onRetry}
          isUploading={isUploading}
          file={filesState.publicUrl?.file}
          error={filesState.publicUrl?.error}
          onFileChange={onFileChange}
          placeholder="Add video file"
          tips={
            <p className="text-sm text-zinc-500">
              The file must be in
              <span className="text-zinc-100">&nbsp;mp4 .webm .mov&nbsp;</span>
              formats and maximum size 100 MB.
            </p>
          }
          maxFileSize={maxVideoPreviewSize}
        />
      </div>
    </div>
  );
}
